__webpack_require__.p = "https://webusstatic.yo-star.com/arknights-us/ark-us-wangsweiqichallenge-h5/prod/arkuswangsweiqichallengeh5/";